const getters = {
  getOrder: function (state) {
    return state.order
  },

  getWSConnectState: function (state) {
    return state.wsConnectState
  },

  getUser: function (state) {
    return state.user
  },

  getUsers: function (state) {
    return state.users
  },

  getLogs: function (state) {
    return state.logs
  },

  getErrorByMethod: state => method => {
    for (let i in state.errors) {
      if (state.errors.hasOwnProperty(i) && i === method) {
        return state.errors[i]
      }
    }
    return null
  },

  getMessageByMethod: state => method => {
    for (let i in state.messages) {
      if (state.messages.hasOwnProperty(i) && i === method) {
        return state.messages[i]
      }
    }
    return null
  },

  getLogsByTypes: state => types => {
    let logs = {};
    for (let i in state.logs) {

      if (!state.logs.hasOwnProperty(i)) continue;

      let logRow = state.logs[i];
      if (types.includes(logRow.event_type)) {
        logs[i] = logRow;
      }
    }

    return logs
  },

  getErrorMessage: state => error => {
    if (error === "wrong call params") return 'При переносе "Передоставка по просьбе клиента" необходимо указать дату и интервал доставки';
    if (error === "wrong uncall params") return 'При переносе "Курьер не дозвонился покупателю" необходимо указать причину недозвона';
    if (error === "no shift type") return 'Не указан тип переноса';
    if (error === "no date fact delivery") return 'Не укахана фактическая дата доставки';
    if (error === "no payment type") return 'Не выбран тип оплаты';
    if (error === "no deny type") return 'Не выбран тип отказа';
    if (error === "no deny reason id") return 'Не выбрана причина отказа';
    if (error === "no find order") return 'Заказа не существует';
    if (error === "login not available") return 'Логин пользователя уже занят';
    if (error === "order not courier") return 'Тип доставки заказа не курьер';

    return error
  },
};

export default getters;



// WEBPACK FOOTER //
// ./src/store/getters.js